module.exports = {"230904011":"东风社区公共服务站","230904012":"康富社区公共服务站","230904013":"湖东社区公共服务站","230904014":"康乐社区公共服务站","230904015":"永泰社区公共服务站","230904016":"通达社区公共服务站","230904017":"惠民社区公共服务站","230904018":"安民社区公共服务站","230904019":"盛馨社区公共服务站","230904020":"欣苑社区公共服务站","230904021":"东胜社区公共服务站","230904022":"富强社区公共服务站","230904023":"龙湖社区公共服务站","230904100":"茄子河镇","230904101":"宏伟镇","230904200":"铁山乡","230904201":"中心河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230904.json
// module id = 771
// module chunks = 0